module.exports = __webpack_public_path__ + "img/mobysign_logo_optimized.9f0a6daf.svg";